import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

const ArticleBadge = ({ classNames, label, type }) => {
  return (
    <span className={cx("article-badge badge m-0", classNames, type, label)}>
      {label}
    </span>
  );
};

ArticleBadge.propTypes = {
  classNames: PropTypes.string,
  type: PropTypes.oneOf(["level", "category"]).isRequired,
  label: PropTypes.string.isRequired,
};

export default ArticleBadge;
